import { render, staticRenderFns } from "./AberrationView.vue?vue&type=template&id=8c13eb52"
import script from "./AberrationView.vue?vue&type=script&lang=ts"
export * from "./AberrationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports